// 导入导出模块
const state = {
  downloadList: [], //间隔下载列表
  downloadUrllist: [], //下载文件的URL列表
  
};

const getters = {
  downloadList(state) {
    return state.downloadList;
  },
  downloadUrllist(state) {
    return state.downloadUrllist;
  }
};

const actions = {};

const mutations = {
  

  //------下载文件的URL数组操作---
  // 删除下载URL
  DELETE_URLLIST(state, data) {
    state.downloadUrllist = state.downloadUrllist.filter(item => {
      return item.eventId !== data;
    });
  },
  // 新增下载URL
  ADD_URLLIST(state, data) {
    state.downloadUrllist.push(data);
  },
  // 整理下载URL
  CHECK_URLLIST(state) {
    state.downloadUrllist = state.downloadUrllist.filter(item => {
      let nowdata = (new Date() - item.time) / 1000;
      return nowdata < 300;
    });
  },

  //------下载文件数组操作---
  // 删除下载文件
  DELETE_FILE(state, data) {
    state.downloadList = state.downloadList.filter(
      item => item.deviceId !== data
    );
  },
  // 新增下载文件
  ADD_FILE(state, data) {
    state.downloadList.push(data);
  },
  // 整理下载文件
  CHECK_FILE(state) {
    state.downloadList = state.downloadList.filter(item => {
      let nowdata = (new Date() - item.time) / 1000;
      return nowdata < 40;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
